import React from "react";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import {
  useGetTicketDetailQuery,
  useUpdateTicketMutation,
} from "store/services/ticketApi";

import { useAppMeta, useAuth } from "hooks";
import VendorTicketForm from "./ticketComponents/VendorTicketForm";

const VendorTicketEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const { isVendor } = useAuth()

  const breadcrumbs = [
    {
      title: "Tickets",
      path: isVendor ? "/app/vendor/ticket/list" : "/app/crm/ticket/list",
    },
    { title: "Edit Ticket" },
  ];

  // RTK Query
  const {
    data: ticketDetail,
    isLoading: loadingTicketDetail,
    error,
  } = useGetTicketDetailQuery(id);

  const [updateTicket, { isLoading: updatingTicket }] =
    useUpdateTicketMutation();

  // methods
  const handleUpdateTicket = async (data) => {
    try {
      await updateTicket(data).unwrap();
      toast.success("Ticket successfully updated!");
      navigate(`/app/crm/ticket/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update ticket!");
    }
  };

  useAppMeta("Edit Ticket");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={updatingTicket || loadingTicketDetail}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <VendorTicketForm
          ticket={ticketDetail}
          onSubmit={handleUpdateTicket}
          isBusy={updatingTicket || loadingTicketDetail}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorTicketEditScreen;
